export const initialState = {
  statistics: []
};
